export default {
    'PaymentChatcomponent.Pay to ': 'Pagar a ',

    'Formulary.SENT (to collect)': 'ENVIADO (para cobrar)',
    'Formulary.RECEIVED (to pay)': 'RECIBIDO (para pagar)',
    'Formulary.You cannot post an invoice where you have to pay': 'No puedes publicar una factura a la que has de pagar',

    'Create.day': 'día',

    'SuggestedFactoringItem.Email ': 'Correo electrónico ',

    'Faucet.AlreadySent': 'Ja se ha enviado hoy el dinero',

    'ByppaySummary.Bypay Summary': 'Resumen del Byppay',
    'ByppaySummary,CERTIFICATE': 'CERTIFICADO',
    'ByppaySummary.The Bypay has been approved for everyone:': 'El byppay ha sido aprobado por las tres partes:',
    'ByppaySummary.PAYER INVOICE': 'FACTURA DEL PAGADOR',

    'FactoringInformation.Factoring information': 'Datos del Byppay',

    'finishCompensation.payerFinish': '{payerCif} paga {amount} € a {receiverCif} a la cuenta {accountNumber}, recibe un descuento de {discount}.',
    'finishCompensation.payerPartial': '{payerCif} paga {amount} € a {receiverCif} a la cuenta {accountNumber}, recibe un descuento de {discount}€ y queda pendiente pagar {outstandingAmount}€ a {oldReceiverCif}.',
    'finishCompensation.receiverFinish': 'Has de recibir {amount} € de {receiverCif} a la cuenta {accountNumber}.\n He recibido una bonificación de {bonus}',
    'finishCompensation.receiverPartial': 'Has de recibir {amount} € de {receiverCif} a la cuenta {accountNumber}, pendiente de recibir {outstandingAmount} de {payerCif}.\n He recibido una bonificación de {bonus}',
    'finishCompensation.middlePayer': '{payerCif} pagará directamente a {receiverCif} , aún has de pagar la cantidad de {outstandingAmount} a {receiverCif}',
    'finishCompensation.middleReceiver': '{payerCif} pagará directament a {receiverCif} , aún has de recibir {outstandingAmount} de {payerCif}',
    'certificate.middle': 'B reconoce que A usará los recursos de la factura AB [{invoiceNumberAB} - ',
    'certificate.middleP2': 'hasta {amount} euro para pagar a C',
    'certificate.middle2': '] que se anota en la compensación',
    'certificate.receiver': 'C reconoce que con este pago de A se compensa {amount} euro de la factura [{invoiceNumberBC} - ',
    'certificate.receiverP2': 'y recibe {amount} euro como intereses de demora',
    'certificate.receiver2': '], que se anota de esta manera ',
    'certificate.payer': 'A reconoce que con este pago recibe un descuento por byppay de {amount} euro incluido en la compensación AB.',
    'certificate.outstanding': 'B reconoce que faltará por pagar {amount} de la factura {invoiceName}',

    'payment.payiedto': 'He pagado a {user}',
    'payment.receivedFrom': 'He recibido el pago de {user}',
    'Payment accepted': 'pago aceptado',
    'Payment received': 'pago recibido',
    'payment.confirmPaymentto': 'Confirma el pago de {user}.',
    'payment.waitingConfirmationto': 'Esperando {user} que confirme el pago.',
    'payment.acceptPaymentFrom': '{user} ha aceptado el pago.',
    'payment.waitingPaymentFrom': 'Esperando {user} para pagar.',
    'payment.confirmPaymentFrom': 'Confirma el pago de {user}.',
    'payment.acceptPayment': 'Has aceptado el pago.',
    'Payment.crypto': 'Pagar con crypto a ',

    'ImageInvoice.Value': 'Valor',
    'ImageInvoice.Provider NIF/CIF': 'CIF/NIF del proveedor',
    'ImageInvoice.Client NIF/CIF': 'CIF/NIF del cliente',
    'ImageInvoice.Invoice Update Successfully': 'Factura subida correctamente',
    'ImageInvoice.Invoice Date': 'Fecha de la Factura',
    'ImageInvoice.Save Invoice': 'GUARDAR FACTURA',
    'ImageInvoice.You cannot use this option due not have a camera device. Use Custom Upload instead!': 'No puedes utilizar esta opción porque no dispones de un dispositivo cone cámara. En su lugar utiliza la carga personalizada!',
    'ImageInvoice.Retry': 'Volver',
    'ImageInvoice.UPLOAD': 'SUBIR',

    'ListInvoicesForCompensate.Candidate invoice for the Forward:': 'Facturas candidatas para el Forward',

    'ListInvoices.Provider': 'proveedor',
    'ListInvoices.Receiver email:': 'Correo electrónico del receptor',
    'ListInvoices.Have to be a number': 'Ha de ser un número',

    'InvoiceView.Invoice not found': 'Factura no encontrada',
    'InvoiceView.Do you want to cancel this bypay?': 'Estás seguro que quuieres cancelar este byppay?',
    'InvoiceView.ERROR: Non-editable invoice': 'Factura no editable',
    'InvoiceView.Invalid status change': 'El cambio de estado del usuari no és válido',
    'InvoiceView.Return amount': 'Cantidad a retornar',
    'InvoiceView.Fullscreen': 'Pantalla completa',

    'Factoring.I ': 'He ',
    'Factoring.accepted the Byppay!': 'aceptado el Byppay!',
    'Factoring.The final state of the bypay is:': 'El estado final del Byppay es:',
    'Factoring.rejected the Byppay!': 'rechazado el Byppay',
    'Factoring.Summary': 'Resumen',
    'Factoring.Waiting': 'Esperando',
    'Factoring.Do you want to reject this bypay?': 'Quieres borrar este byppay?',

    'RemindOptions.Notify Via...': 'Notificar vía...',
    'RemindOptions.If necessary, enter the phone number to send a SMS notification.': 'Si fuese necesario, entra el número de teléfono para enviar una notificación via SMS.',
    'RemindOptions.If necessary, enter the phone number to send a Whatsapp notification.': 'Si fuese necesario, entra el número de teléfono para enviar una notificación via WhatsApp.',
    'RemindOptions.Reminded successfully': 'Recordado satisfactóriamente',

    'LandingPage.KNOW MORE': 'PARA SABER MÉS',
    'LandingPage.WHAT IS BYPPAY?': 'QUÉ ES BYPPAY?',
    'LandingPage.Upload your invoices': 'Sube tus facturas',
    'LandingPage.Choose which of the invoices your customers will pay your providers': 'Selecciona qué factures de tus clientes pagarán a tus proveedores',
    'LandingPage.Once accepted, you will get your certificate': 'Una vez aceptado, obtendrás tu certificado',
    'LandingPage.Check your compensations': 'Consulta tus compensaciones',
    'LandingPage.WHY BYPPAY?': 'POR QUÉ BYPPAY?',
    'LandingPage.FAST': 'RÁPIDO',
    'LandingPage.Thanks to its BlockChain technology, Bypay allows you to create in a few hours a direct payment agreement between customers and providers': 'Gracias a su tecnología Blockchain, Byppay permite crear en pocos minutos un acuerdo de pago directo entre clientes i proveedores',
    'LandingPage.ECONOMIC': 'ECONóMICO',
    'LandingPage.Byppay avoids the consequences of being an intermediary between customer and provider. Byppay does not depend on any bank': 'Byppay evita las consecuencias de ser intermediario entre cliente y proveedor. Byppay no depende de ningún banco',
    'LandingPage.SAFE': 'SEGURO',
    'LandingPage.Bypay uses DLT technology to secure payment agreements between customer-provider.': 'Byppay utiliza tecnología DLT para asegurar los acuerdos de pago entre cliente-proveedor.',

    'LandingAC. is a digital system that makes it easier for all those entrepreneurs to pay their providers through potential clients in times of crisis in a fast, cheap and safe way.': 'Byppay es un sistema digital que facilita a todos aquellos empresarios a pagar a tiempo a sus proveedores a través de clients potenciales en tiempos de crisis, de manera rápida, barata i segura.',

    'MoreInfo.Upload the invoice to be paid to the web-app': 'Sube la factura a pagar a la webApp',
    'MoreInfo.HOW IT WORKS?': 'CÓMO FUNCIONA?',
    'MoreInfo.Request payment of the invoice to the customer you want': 'Solicita el pago de la factura al client que desees',
    'MoreInfo.The app automatically negotiates a customer-provider agreement': 'La aplicación negocia automáticamente un acuerdo cliente-proveedor',
    'MoreInfo.You will receive a payment confirmation when the provider has paid the customer, as well as a certificate proving payment': 'Recibirás una confirmación de pago cuando el proveedor haya pagado al cliente, así como un certificado que acreditará el pago',
    'MoreInfo.is a digital platform that works worldwide and is VAT neutral. It allows you not to advance money to your provider without having received your client\'s income. These payments they are registered with DLT (Distribution Ledger Technology) which makes a valid and secure agreement possible.': 'es una plataforma digital que funciona en todo el mundo y que es IVA-neutral. Permite garantizar el pago a vuestro proveedor sin haber recibido el ingreso de vuestro cliente. Estos pagos se registran en una Blockchain, cosa que hace posible un acuerdo válid y seguro.',
    'MoreInfo.It is a financial solution that works with Ethereum which makes it a DeFi (Decentralized Finance) solution. By the end of 2021, more than 100,000 European SMEs will avoid bills thanks to the digitization of agreements and payments with DeFi solutions such as': 'És una solución financiera que funciona con Polygon/Ethereum, cosa que lo convierte en una solución DeFi (finanzas descentralizadas). A finales del 2026, más de 100.000 pimes europees pagarán sin problemas las facturas gracias a la digitalización de acuerdos y pagos con soluciones DeFi como son',
    'MoreInfo.An invoice is a commercial document that indicates the sale of a good or service and that, among other things, must include all the information of the operation. It has legal and fiscal validity. We can say that it is an accreditation of a transfer of a product or service after purchasing it.': 'Una factura es un document comercial que indica la venda de un bien o servicio y que, entre otras cosas, ha de incluir toda la información de la operación. Té validez legal y fiscal. Podemos decir que se trata de una acreditación de una transferencia de un producto o servicio después de comprarlo',
    'MoreInfo.What is an invoice?': 'Qué és una factura?',
    'MoreInfo.What is a byppay?': 'Qué és un byppay?',
    'MoreInfo.Through the bypay mechanism, a company can pay the invoices to its suppliers with the invoices of its clients.': 'Mediante el mecanismo de byppay, una empresa puede pagar les factures a sus proveedores con las facturas de sus clientes',
    'MoreInfo.It is the reverse procedure to bypay, through which a company invoices from clients (to be collected) can be sent to our suppliers to pay their invoices.': 'Es el procediment inverso al byppay, mediante el cual se pueden enviar las facturas de una empresa a los clientes (que se han de cobrar) a nuestros proveedores para pagar sus facturss',
    'MoreInfo.The main benefit that the company obtains when executing this operation is to offset invoices. This, by extension, improves the financing capacity of the business.': 'La principal ventaja que obtiene la empresa en ejecutar esta operación es compensar las facturas. Esto, por extensión, mejora la capacidad de finanzación del negocio',
    'MoreInfo.It is the technology that ensures that the actions related to a bypay / factoring are registered without the possibility of being altered in the future. Certify the validity of the process.': 'Es la tecnología que garantiza que las acciones relacionadas con un byppay se registren sin la posibilidad de ser alteradas en el futur. Certifica la validez del proceso.',
    'MoreInfo.FAST, CHEAP & SAFE': 'RáPIDO, ECONóMICO Y SEGURO',
    'MoreInfo.You pay your invoices by bypaying income directly to your providers. No cash, no funding are needed. The app uses DLT/Blockchain to secure the byppay agreements': 'Pagad las facturas con vuestros ingresos directament a vuestros proveedores. No hace falta cash, no es necesita financiación. La aplicación utiliza DLT / Blockchain para proteger los acuerdos de byppay',
    'MoreInfo.HOW DOES IT WORK?': 'COMO FUNCIONA?',
    'MoreInfo.Upload your providers and clients invoices into the app. The app will propose byppaying some invoices: When your clients pay directly to your providers, you have paid then indeed, and invoices compensated!': 'Subid las facturas de los proveedores y de los clientes a la aplicación. Ella propondrá hacer byppay de algunas facturas: cuando vustros clientes paguen directamente a vustros proveedores, ja habreis pagado y las facturas se an compensado.',
    'MoreInfo.A NEW NORMAL': 'UNA Nueva NORMALIDAD',
    'MoreInfo.Byppaying is the fastest, cheapest and safest funding in the market.': 'El byppay és la financiación más rápida, más barata y más segura del mercado',

    'ByppayList.No bypay has yet been initiated with this invoice.': 'Aún no se ha iniciado ningçun byppay con uesta factura.',

    'ItemListChat.REMAIN': "FALTANDO",

    'AdminCommissions.Receiver comission': 'Interés de demora pel proveedor',
    'AdminCommissions.Platform comission': 'Comisión de la plataforma',
    'AdminCommissions.Byppay Commision': 'descuento pel Cliente',

    'CollateralModal.Add to list': 'Añadido a la llista',
    'CollateralModal.Minimum value to pay': 'Minimo valor a pagar: ',
    'CollateralModal.Email list notification': 'Listado de correos a quien notificar la publicación al mercat. Los correos estarán separats por comas.',
    'Collateralmodal.MessagePublish': 'Para poder publicar al marketplace hace falta pagar como mínimo un {porcentaje} % de la factura ',

    'CollateralView.Anonymous': 'Anónimo',

    'AcceptBypayes.Approve byppayes': 'Aprobar byppays',

    'NavigationMenu.Invoices to pay': 'Facturas a pagar',
    'NavigationMenu.Invoices to be payed': 'Facturas a cobrar',
    'NavigationMenu.Clients': 'Clientes',
    'NavigationMenu.Marketplace': 'Marketplace',
    'NavigationMenu.AMM': 'rkAMM',
    'NavigationMenu.Faq': 'Preguntas Frecuentes',
    'NavigationMenu.Chat': 'Chat',

    'MainView.Min Date': 'Fecha Mínima',
    'MainView.Min-Max Amount': 'Cantidad Min-Max',
    'MainView.Introduce Min and Max Date': 'Introduce la Fecha Mínima y/o Máxima',
    'MainView.To get paid': 'Recibir',
    'MainView.Error listing invoices': 'Error al listado de facturas',
    'Mainview.There are no invoices yet': 'Aún no tienes ninguna factura',
    'MainView.Failed': 'Fracasado',
    'MainView.Advanced Options': 'Opciones avanzadas',
    'MainView.Reset': 'Restablecer',
    'MainView.Filter': 'Filtrar',
    'MainView.Archived': 'Archivado',

    'InvoiceChats.No messages in chat': 'No hay mensages en este chat',
    'InvoiceChats.My chats': 'Mis chats',

    'AcceptBypaymentChatComponent.Decline': 'Rechazado',

    'VideoInput.Record Video': 'Grabar Vídeo',

    'ItemListChat.Receive': 'Recibir',
    'ItemListChat.Invited': 'Invitado',

    'InviteChatForm.Send MAIL': 'Enviar EMAIL',
    'InviteChatForm.Send SMS': 'Enviar SMS',
    'InviteChatForm.Send Whatsapp': 'Enviar Whatsapp',
    'InviteChatForm.InviteEmail': 'Invitar por email',
    'InviteChatForm.InvitePhone': 'Invitar pór móvil',

    'AddInvoiceToChat.AddInvoice': 'Añade factura al chat',

    'Invoice': 'Factura',
    'ItemMessageFormInvite.Invite': 'Invitar',
    'AllFilesChat.with': 'con',
    'chat.newChat': 'Mensaje de bienvenida',
    'chat.newChatExtra': 'A continuación se muestra el vídeo de bienvenida y un enlace con los primeros pasos a seguir',
    'chat.remindInvite': 'Recordatorio invitación',

    'chat.inviteDownStream': '{user} ha invitado {userInvited}. Esperando que {userInvited} accepte',
    'chat.inviteDownStreamExtra': '{userInvited} ha de acceptar la invitación y unirse al chat. \n En caso de no aceptar puedes enviar un recordatorio de unirse al chat',
    'chat.inviteUpStream': '{user} ha invitado {userInvited}. Esperando que {userInvited} acepte (byppay)',
    'chat.inviteUpStreamExtra': '{userInvited} ha de acceptar la invitación y unirse al chat. \n En caso de no accptar puedes enviar un recordatorio de unirse al chat',

    'chat.enterDownStream': '{user} ha entrado en el chat (invoice)',
    'chat.enterDownStreamExtra': '{payerUser} ha de añadir la factura de {user}',
    'chat.enterUpStream': '{user} ha entrado en el chat (byppay)',
    'chat.enterUpStreamExtra': 'pendiente que {user} pague la factura',
    'chat.payed': '{user} ha pagado la factura',
    'chat.payedExtra': '{user} ha pagado la factura',
    'chat.acceptedByppay': '{user} ha aceptado el byppay',
    'chat.acceptedByppayExtra': 'Pendiente invitar el otro participante del byppay',
    'chat.rejectedByppay': '{user} ha rechazado el byppay',
    'chat.rejectedByppayExtra': '{user} ha rechazado el byppay',
    'chat.byppayPayed': 'Byppay pagado',
    'chat.byppayPayedExtra': 'Byppay pagado',
    'chat.invoiceGenerated': 'Se han generado las facturas compensadas.',
    'chat.invoiceGeneratedExtra': '{user} es el propietario de la Nueva factura',
    'chat.acceptPaymentOutsidePlatform': 'Aceptar pago fuera de la plataforma',
    'chat.acceptPaymentOutsidePlatformExtra': 'pago hecho y aceptado fuera de la plataforma; factura finalitzada',
    'chat.paymentOutsidePlatform': 'Pago fuera de la plataforma ',
    'chat.paymentOutsidePlatformExtra': 'El receptor de la factura ha de acceptar el pago hecho fuera de la plataforma',
    'chat.ButtonAcceptPaymentOutsidePlatform': 'Aceptar pago fuera de la plataforma',
    'chat.newDate': '{día}/{mes}/{año}',
    'cat.nopaymentmethods': 'No hay métodos de pago',
    'chat.set-payment': '{user} ha introducido los métodos de pago',
    'chat.set-paymentExtra': 'Pendient que {payer} pague o byppague la factura',
    'chat.see-invoice': 'Ver facturas',
    'chat.see-files': 'Ver ficheros',
    'chat.edit-payment-info': 'Modificar información de pago',
    'chat.view-contract': 'Ver contrato',
    'chat.stipe-public-key': 'Clave pública de Stripe',
    'chat.stipe-private-key': 'Clave privada de Stripe',
    'chat.public-crypto-address': 'Clave pública Crypto',
    'chat.remind-introduce-payment-methods': 'Recuerda introducir los métodos de pago',
    'chat.remind-paymentMethod': '{user} Recuerda introducir los métodos de pago',
    'chat.remind-paymentMethodExtra': 'Esperando que {payer} introduzca los métodos de pago',
    'chat.invoice-added': '{user} ha añadido una factura',
    'chat.invoice-addedExtra': 'Pendiente de entrar métodos de pago del receptor {receiver}',
    'chat.byppay-added': '{user} ha añadido un byppay',
    'chat.byppay-addedExtra': 'Pendiente de ser aceptado por {receiver}',
    'chat.remind-to-pay': 'Recordatorio de pago',
    'chat.remind-to-payExtra': '{user} envía un recordatorio de pago a {payer}',
    'chat.file-input': 'Subier fichero',
    'chat.add-file': 'Añadir fichero',
    'chat.noInvoiceInChat': 'No hay aún niguna factura en el chat',
    'chat.remind-join-chat': 'Recordar unirse al chat',
    'chat.insertMessage': 'Has de entrar un mensaje',
    'chat.insertFile': 'Has de entrar un fichero',
    'chat.archive-chat': 'Archivar el chat',
    'chat.unarchive-chat': 'Desarchivar el chat',
    'chat.add-to-calendar': 'Añadir al Calendario',
    'Chat.helpCenter': 'Centro de ajuda',
    'Chat.Message': 'mensaje',
    'Chat.errorMessageHelp': 'Error al buscar mensage de ayuda',
    'PaymentInformationBytton.AddPaymentMethod': 'Introduce métodos de pago',


    'allFiles.files-in-invoice': 'ficheros de la factura',
    'invoice.go-to-chat': 'Ir al chat',
    'invoice.acrhive': 'Archivar',
    'invoice.archived': 'Desarchivar',
    'Invoice.Go Back': 'Volver',
    'Invoice.Invoice Detail': 'Detalle de la Factura',

    'createInvoice.nifReceiver': 'CIF/NIF del receptor',
    'createInvoice.nifPayer': 'CIF/NIF del pagador',

    'Login.LogoutUnregisteredUser': 'Cierra la sessión com a usuario no registrado',
    'Login.Forgot Password?': 'Has olvidado la contraseña?',
    'Login.New to Byppay?': 'Aún no tienes una cuenta? ',
    'Login.Reset the Password!': 'Restablece la contraseña!',
    'Login.Send email': 'Envia un correo electrónico',
    'Login.Change the Password!': 'Cambia la contraseña!',
    'Login.New Password': 'Nueva contraseña',
    'Login.New Password Confirmation': 'Nueva confirmación de la contraseña',
    'Login.Change password': 'Cambia la contraseña',
    'Login.Logged out succesfully!': 'Sesión cerrada correctamente',
    'Login.ERROR: Invalid token, check again the URL on your e-mail': 'ERROR: Token inválido; revisa la URL del correo',
    'Login.ERROR: You are already validated': 'ERROR: Ja estás validado',
    'Login.You let empty params, check it again please': 'Has dejado parámetros vacíos: vuévelo a revisar, por favor',
    'Login.Logged successfully!': 'Sesió iniciada correctamente!',
    'Login.Check your email in order to reset the password': 'Comprueba tu correo electrónico para restablecer la contraseña',
    'Login.Error: Cannot send an email to reset you password. Please check the email you enter.': 'Error: no se puede enviar un correo electrónico para restablecer la contraseña. Comprueba el correo electrónico que has introducido',
    'Login.You can now log in': 'Ahora puedes iniciar la sesión',
    'Login.Passwords doesn\'t match': 'Las contraseñas no coinciden',
    'Login.Register': 'Registrarse',
    'Login.ERROR: Missing fields on the formulary': 'ERROR: Faltan campos en el formulario',
    'Login.ERROR: User not found': 'ERROR: Usuario no encontrado',
    'Login.ERROR: Wrong password': 'ERROR: contraseña incorrecta',
    'Login.ERROR: User is not validated': 'ERROR: El usuario no está validado',
    'Login.about': 'Sobre byppay',
    'Login.Welcome Back': 'Bienvenido!',
    'Login.SubTitle': 'Solo unos segundos y ya está todo listo.',
    'Login.LanguageTitle': 'Elija su idioma',

    'Register.Your Name': 'Tu nombre',
    'Register.Use 6 characters with a mix of letters, numbers & symbols': 'Utiliza 6 caracteres con una combinación de letras, números y símbolos',
    'Register.Registered succesfully! Please check your email for the validation': 'Registro completado con éxito! Revisa tu correo para validarte',
    'Register.ERROR: The user couldn\'t be saved': 'ERROR: El usuario no se ha podido guardar',
    'Register.ERROR: E-mail already in use': 'ERROR: El correo ja está en uso',
    'Register.ERROR: CiF already in use': 'ERROR: El CIF ja está utilizado',
    'Register.By signing up, you agree to Byppay of Use & Privacy Policy': 'Al registrarte, acepta la ',
    'Register.Policy': 'Política de uso y privacidad de Byppay',
    'Register.Already signed up? ': 'Ya estás registrado? ',
    'RegisterLayout.Title': 'Rellena el formulario',
    'AllFilesChat.notImages': 'aún no hay ninguna imagen en el chat',
    'AllFilesChat.pdfs': 'aún no hay ningún pdf en el chat',
    'AllFilesChat.images': 'Imágenes',
    'AllFilesChat.head': 'ficheros en el chat ',
    'AllFilesChat.headGroup': 'ficheros en el grupo ',
    'chat.pdf': 'Ver contrato',
    'chat.download': 'Descargar contrato en pdf',

    'BrowseScroll.head': 'Factura número ',
    'BrowseScroll.undefined': 'indefinida',
    'BrowseScroll.Fecha': 'DATOS',

    'Button.accept': 'Aceptar',

    'InvoiceChats.registeredError': 'Has de estar registrado para utilizar esta función',
    'invoiceChats.Archived': 'Ver chats archivados',
    'InvoiceChatsArchived.noChats': 'No hay ningún chat archivado aún',
    'InvoiceChatsArchived.returnToChats': 'Volver a los chats',
    'InvoiceChatsArchived.head': 'Estos chats están archivados actualmente. Para desarchivarlos entra al chat',
    'InvoiceChats.MessagePresentation': 'mensaje de presentación Byppay',
    'InvoiceChats.There are no chats created yet': 'No hay chats creados aún',
    'InvoiceChats.Welcome back': 'Bienvenido!',
    'InvoiceChats.InviteContacts': 'Pague sus facturas o reciba pagos usando el botón “+”.',
    'InvoiceChats.Foto': 'Foto',


    'Notifications.Notification List': 'Lista de notificaciones',
    'Notifications.Error get notifications': 'Error para mostrar las notificaciones',

    'AllInvoicesChat.headGroup': 'Lista de facturas en el chat',

    'Profile.Logged out succesfully!': 'Sesión cerrada correctamente!',
    'Profile.Profile': 'Perfil',
    'Profile.Name': 'Nombre',
    'Profile.Surname': 'Apellidos',
    'Profile.Address': 'Dirección',
    'Profile.Country': 'País',
    'Profile.Wallet Address': 'Dirección de la cartera',
    'Profile.Exange ratios': 'Ratios de cambio',
    'Profile.Euro to byto ratio': 'Ratio de cambio euro a byto',
    'Profile.Platform amount': 'Total de la plataforma',
    'Profile.Don\'t show the splash screen at the beggining': 'No mostrar la pantalla de presentación al inicio',
    'Profile.Do you want to logout?': 'Quieres cerrar sesión?',
    'Profile.Payer comission': 'descuento del pagador',
    'Profile.My profile': 'Mi perfil',

    'Create.Invoices': 'Facturas de:',
    'Create.Status': 'Estado',
    'Create.days': 'días',
    'Create.Invoice deleted successfully!': 'La factura se ha eliminado con éxito',
    'Create.Error deleting the invoice': 'Error al eliminar la factura',

    'InvoiceStatus.Payed': 'Pagada',
    'InvoiceStatus.Pending': 'Pendiente',
    'InvoiceStatus.Unpayed': 'No pagada',
    'InvoiceStatus.Charged': 'Cobrada',
    'InvoiceStatus.Created': 'Creada',
    'InvoiceStatus.Compensated': 'Compensada',
    'InvoiceStatus.Temporary': 'Temporal',
    'InvoiceStatus.Unknown': 'Desconocido',
    'InvoiceStatus.ERROR: Cannot get blockChain Fecha': 'ERROR: No se ha podido obtener los datos de la Blockchain',

    'InvoiceInformation.BlockChain Information': 'Información de la BlockChain',
    'InvoiceInformation.Basic Information': 'Información Básica',
    'InvoiceInformation.Link to Blockchain': 'Enlace a la Blockchain',
    'InvoiceInformation.Blockchain Amount': 'Importe de la Blockchain',
    'InvoiceInformation.Blockchain Date': 'Fecha de la Blockchain',
    'InvoiceInformation.Blockchain Status': 'Estado de la Blockchain',
    'InvoiceInformation.BlockChain': 'Blockchain',
    'InvoiceInformation.See transaction': 'Ver transacción',
    'InvoiceInformation.There is no Fecha for this invoice stored on the Blockchain.': 'No hay ningún dato sobre esta factura en la Blockchain.',

    'CreateInvoiceModal.NEW INVOICE': 'Nueva FACTURA',
    'CreateInvoiceModal.MODIFY INVOICE': 'MODIFICAR FACTURA',

    'SpecificCompensation.Pending Compensations': 'Compensaciones Pendientes',

    'Bypaysummary.Compensated': 'Compensada',

    'SmallInvoce.Me': 'Yo',

    'FactoringLogic.Petition modified successfully!': 'La petició ha sido modificada con éxito!',

    'PendingFactoringItem.Do you want to accept this bypay?': 'Estás seguro de acceptar este byppay?',
    'PendingFactoringItem.Petition accepted successfully!': 'La petición ha sido acceptada con éxito!',
    'PendingFactoringItem.USER NOT LOGGED!': 'BIENVENIDO A BYPPAY',
    'PendingFactoringItem.You are not logged into the platform, please login or register to perform some action': 'Por favor, haz login o regístrate para gestionar la compensación de facturas',

    'SuggestedFactoringItem.DESTINY EMAILS': 'E-MAILS DESTINO',
    'SuggestedFactoringItem.Do you want to propose your partners this bypay?': 'Quieres proponer este byppay al cliente y al proveedor?',
    'SuggestedFactoringItem.already exists, use another email!': ' ya existente, utilitza otra!',
    'SuggestedFactoringItem.Are you sure?': 'Estás seguro?',
    'SuggestedFactoringItem.Do you want to decline this bypay proposal?': 'Quieres rechazar esta propuesta de byppay?',
    'SuggestedFactoringItem.The platform suggests you to perform the following compensation:': 'La plataforma os sugiere que realicéis las compensaciones siguientes',

    'InvoiceMissingInformation.Payer CIF': 'CIF del pagador',
    'InvoiceMissingInformation.Payer email:': 'correo electrónico del pagador',
    'InvoiceMissingInformation.Payer email': 'Email del pagador',
    'InvoiceMissingInformation.Receiver CIF': 'CIF del receptor',
    'InvoiceMissingInformation.Receiver email': 'Email del receptor',
    'InvoiceMissingInformation.Receiver NIF/CIF, Mail & name': 'NIF/CIF, Mail & nombre del receptor',
    'InvoiceMissingInformation.Payer NIF/CIF, Mail & name': 'NIF/CIF, Mail & nombre del pagador',
    'InvoiceMissingInformation.Account number:': 'Número de cuenta:',
    'InvoiceMissingInformation.Update': 'Actualiza',

    'MyInvoices.PublishAMM': 'Quieres publicar el Byppay al rkAMM y cobrarla por adelantado',
    'MyInvoices.CollectByppay': 'Collect Byppay',
    'AmmModal.MessageInformation': 'Parar cobrar el byppay a través del rkAMM hay que pagar un premium con un coste de:',
    'AmmModal.ValueToPay': 'Valor a pagar',


    'Help.HELP': 'AYUDA',
    'Help.Forward': 'Se realiza Byppay como un factoring',
    'Help.when you propose your providers if they want to be paid directly from your clients.': 'cuando propongas a tus proveedores si quieren ser pagados directamente por tus clientes',
    'Help.Bypay': 'Se realiza Byppay como un aval',
    'Help.when you ask your clients to pay your providers or when you want any client of your client to pay directly': 'cuando quieras que cualquier cliente de tus clientes te pague directamente',
    'Help.If you are owner of a small business or self-employed': 'Si ere propietario de un pequeño negocio o autónomo',
    'Help.Bypaying and forwarding invoices saves valuable cash and cash-in time, frees you from bank loans, and enhances your scoring': 'Hacer Byppay en vez de Factoring o Aval de factures te ahorra tiempo y dinero en efectiu, te libera de préstamos bancarios i mejora tu scoring bancario',
    'Help.It is way cheaper than banks, safer, faster, and requires no burocracy thanks to the blockchain technology': 'Es menos costoso que los bancos, más seguro, más rápido y no tiene burocracia gracias a la tecnología Blockchain',
    'Help.Try it! Byppay': 'Pruébalo! Byppay',


    "admin.NETWORK_ERROR": 'Xarxa incorrecte.',
    "admin.Comissions": 'Comissions de la plataforma',
    "admin.EditableMessages": 'Editar mensajes',
    "admin.Exchange": 'Gestionar exchange',

    "exchange.NoTransactions": 'No hay transacciones',
    "EditableSystemMessages.Save Tag": "Guardado",

    "faucet.AddFunds": "Añadir dinero",

    'Pay': 'Pagar',
    'CANCEL': 'CANCELAR',
    'or': 'o',
    'NIE/NIF': 'NIE/NIF',
    'Password': 'Contraseña',
    'LOG IN': 'INICIAR SESIÓN',
    'SIGN UP': 'REGISTRARSE',
    'ERROR: Something went wrong': 'ERROR: Alguna cosa no ha funcionado',
    'E-mail': 'Correo electrónico',
    'Phone number': 'Número de teléfono',
    'Back': 'Atrás',
    'Save': 'Guardar',
    'From: ': 'De: ',
    'To:': 'A:',
    'Logout': 'Cerrar sesión',
    'Already exists a user with this CIF': 'Ya existe un usuario con este CIF',
    'Already exists a user with this Email': 'Ya existe un usuario con este correo',
    'Amount': 'Cantidad',
    'AMOUNT': 'Cantidad',
    'Outstanding Amount': 'Importe Pendiente',
    'DATE': 'Fecha',
    'Date': 'Fecha',
    'Delay': 'Retraso',
    'Payer': 'Pagador',
    'Receiver': 'Receptor',
    'Cancel': 'Cancelar',
    'OK': 'De acuerdo',
    'The invoice number you have entered already exists': 'El número de la factura introducido ya existe!',
    'The phone must be valid': 'El teléfon ha de ser válido',
    'The mail must be valid.': 'El correo ha de ser válido',
    'This certificate reflects the agreement executed by the three parties': 'este certificado refleja el acuerdo ejecutado por las tres partes',
    'Factoring information:': 'Información del Byppay',
    'Compensation': 'Compensación',
    'Payer invoice:': 'Factura del Pagador:',
    'Receiver invoice:': 'Factura del Destinatario:',
    'Success changing the payment status': 'éxito al cambiar el estado del pago',
    'Error changing the payment status': 'Error al cambiar el estad del pago',
    'Close': 'Cerrar',
    'CLOSE': 'CERRAR',
    'ConfirmationModal.Yes': 'Sí',
    'The value field is required': 'El campo valor es obligatorio',
    'The phone field is required': 'El campo del teléfono és obligatorio',
    'Comission must be greater than 0': 'La comisión ha de ser mayor que 0',
    'Sent': 'Clientes',
    'Received': 'proveedores',
    'Petition rejected': 'Petición rechazada',
    'Remaining to pay:': 'Falta por pagar: ',
    'Remaining to receive:': 'Falta por cobrar: ',
    'Waiting for your partner': 'Esperando a la otra parte',
    'Your partner': 'Tu cliente',
    'is asking you to simplify the next invoices:': 'te pide que compenses las facturas seguientes:',
    'User': 'Usuario',
    'offers you to change the next invoice:': 'te ofrece compensar esta factura:',
    'offers to pay you the next invoice:': 's\'te ofrece a pagarte esta factura:',
    'No more payments required!': 'No hacen falta más pagos!',
    'You pay': 'Pagarás',
    'to': 'a',
    'will pay': 'pagará',
    'You receive': 'Tu recibes',
    'from': 'de',
    'to accept or deny this bypay.': 'para aceptar o rechazar este byppay.',
    'has denied this bypay.': 'ha rechazado este byppay.',
    'This bypay has been approved by': 'este byppay ha sido aprobado por',
    'all': 'todas',
    'partners!': 'las partes!',
    'Accepted': 'Acceptada',
    'COMPARATIVE INVOICES': 'COMPARACIÓN FACTURAS',
    'INVOICE NUMBER ': 'NÚMERO DE FACTURA ',
    'New Payer: ': 'Nuevo Pagador: ',
    'New Receiver: ': 'Nuevo Receptor: ',
    'New Amount: ': 'Nueva Cantidad: ',
    'Catalan': 'Catalán',
    'Spanish': 'Castellano',
    'English': 'Inglés',
    'Accept': 'Aceptar',
    'Confirm': 'Confirmar',

    'Number:': 'Número: ',
    'Payer CIF:': 'CIF del Pagador: ',
    'ShowInvoiceInformation.New Payer cif: ': 'Nuevo CIF del Pagador: ',
    'Receiver CIF:': ' CIF del Receptor: ',
    'ShowInvoiceInformation.New Receiver cif: ': 'Nuevo CIF del Receptor: ',
    'Download': 'Descarga',
    'DOWNLOAD': 'DESCARGA',
    'ERROR: The invoice couldn\'t be saved, try again': 'ERROR: La factura no ha podido ser guardada; inténtalo un altre cop',
    'ERROR: Invoice number already exists': 'ERROR: El número de la factura ja existe',
    'Saved successfully!': 'Guardada con éxito',
    'Error paying invoice': 'Error al pagar la factura',
    'Invoice payed successfully!': 'La factura ha sido pagada con éxito',
    'Do you want to delete this invoice?': 'Estás seguro de borrar esta factura?',
    'Confirmation': 'Confirmación',
    'Refreshing...': 'Refrescando...',
    'Refreshing..': 'Refrescando..',
    'My NIF/CIF': 'El meu NIF/CIF',
    'INVOICE NUMBER': 'NÚMERO DE FACTURA',
    'Invoice Number': 'Número de Factura',
    'Missing Fecha': 'Falta información',
    'Login': 'Iniciar Sesión',
    'Client': 'Cliente',
    'Upload Invoice': 'Introduce Factura',
    'CLIENT': 'CLIENTE',
    'Account number': 'Número de cuenta',
    'ACCOUNT NUMBER': 'NÚMERO DE CUENTA',
    'is going to pay this invoice to you by asking his client to do it: ': 'te pagará esta factura proponiendo a su client el hacerlo',
    'EMAIL': "correo electrónico",
    'You must enter the email of the ': 'Has de entrar el correo electrónico del ',
    'receiver!': 'receptor!',
    'payer!': 'pagador!',
    'You not have Candidates!': 'No tienes ninguna factura candidata disponible!',
    'Participant': 'Participante',
    'GO': 'Adelante',
    'Email': 'correo electrónico',
    'Upload Candidate': 'Añade una Candidata',
    'Due Date': 'Terminio',
    'Rossum have detected the next information:': 'Rossum ha detectat la siguiente información:',
    'Do you want to import?(in the next screen you can modify the fields)': "Quieres importar? (En la pantalla següent puedes modificar los campos)",
    'Import information?': 'Importa información?',
    'Click on the contact to send the message via SMS and check the box': 'Haz clic en el contacto para enviar el mensaje via SMS y marca la casilla',
    'Click on the contact to send the message via Whatsapp and check the box': 'Haz clic en el contacto para enviar el mensaje via Whatsapp y marca la casilla',
    'Phone of ': 'Teléfono de ',
    'Notification options': 'Opciones para notificar',
    'How do you want to notify compensation?': 'Como quieres notificar la compensación?',
    'is a platform that facilitates payments to providers through potential customers in a fast, economical and secure way': 'es una plataforma que facilita el pago a proveedorse a través de los clientes potenciales de una manera rápida, económica y segura',
    'UPLOAD INVOICE': 'SUBIR FACTURA',
    'Register to byppay.com': 'Registrate a byppay.com',
    'PAY YOUR INVOICES WHEN NO CASH': 'PAGA TUS FACTURAS CUANDO NO TIENES EFECTIVO',
    'Dark': 'Oscuro',
    'Log in': 'Iniciar sesión',
    'Sign Up': 'Registrarse',
    'Facebook Log in': 'Inicio de sesió con Facebook',
    'Google Log in': 'Inicio de sesión con Google',
    'I am waiting for your decision. Please go to this link to make an action: ': 'Estoy esperando tu decisión. Visita el enlace para realizar una acción:',
    'In order to do this option you need to login, Do you want to login?': 'Para usar esta opción has de iniciar sessión: ¿quieres iniciarla?',
    'RECEIVER INVOICE': 'FACTURA DEL RECEPTOR',
    'To pay': 'Pagar',
    '|Policies': '|Políticas',
    'Outstanding amount': 'Importe pendiente',
    'Delete': 'Eliminar',
    '+ Add Contact': '+ Añadir Contacto',
    'OUTSTANDING AMOUNT': 'CANTIDAD PENDIENTE',
    'Certificate number': 'Número de certificado',
    'Debtor (A)': 'Deudor (A)',
    'Creditor (B)': 'Acreedor (B)',
    'Beneficiary (C)': 'Beneficiario (C)',
    'Manifested agreement': 'Resumen del acuerdo de byppay',
    'Payment Accepted': 'pago aceptado',
    'Record a video for your partners': 'Graba un video para invitar al byppay',
    'Skip': 'Saltar',
    'NotificationTypesForCompensate.DON\'T NOTIFICATE': 'No notifiques',
    'Quantity that A deduces from his debt with B through a payment to C': 'Cantidad que A deduce de su deuda con B mediante un pago a C',
    'Payment from debtor (A) to beneficiary (C)': 'pago del deudor (A) al beneficiario (C)',
    'To the following account': 'A la siguiente cuenta',
    'From': 'De',
    'To': 'A',
    'Add liquidity': 'Añadir liquidez',
    'Message Add Liquidity': 'Cantidad de líquido a aportar',
    'Payment with stripe:': 'pago con stripe:',
    'Error.User not found': 'Usuario no encontrado',
    'Error.Something went wrong': 'Agluna cosa no ha funcionado',
    'Pay with crypto': 'Pagar con criptomonedas',
    'I payed outside of platform': 'He pagado fuera de la plataforma',
    'CompensationSteper.Select allowed payment methods': 'Selecciona los métodos de pago',
    'Error: pay collateral': 'Error al pagar los colaterales',
    'Collateral payed': 'Colateral pagado',
    'payProvider': 'Usarás la factura de un cliente para pagar hasta {invoicePrice} € a este proveedor. ¿Proceder?',
    'Do you want to remove this invoice bypay forever?': '¿Realmente desea eliminar esta factura por pago?',

    'Amount:': 'Cantidad:',
    'Error.Error deleting bypay': 'Error al eliminar el byppay',
    'Error.Error accepting petition': 'Error al acceptar la petición',
    'Error.Error modifying petition': 'Error al modificar la petición',
    'Error.The mail field is required': 'El campo email es obligatorio',
    'Error.Error rejecting petition': 'Error al rechazar la petición',
    'Error.This field is required': 'este campo és obligatori',
    'Error.The CIF must be different than yours.': 'El CIF ha de ser diferente del tuyo.',
    'Error.The CIF must be valid (Example formats: A12345678, 12345678B, C1234567D)': 'El CIF ha de ser válido (Formatos de ejemplo: A12345678, 12345678B, C1234567D)',

    'Success.Bypay deleted successfully!': 'El byppay se ha borrado con éxito.',
    'EditContact.SAVE': 'Guardar',
    'RelatedInvoice': 'Factura relacionada',

    'error.NoMoney': 'Te falta diner para pagar.',
    'error.NoMoney.Faucet': 'Ir a la faucet',
    'error.NoWallet': 'No tienes un criptomonedero configurado.',
    'error.NoWallet.Video': 'Ir al video explicativo',

    'LandingPage.WelcomeMessage1': 'Bienvenido a Byppay,',
    'LandingPage.WelcomeMessage2': 'la más rápida y asequible solución para el pago de facturas.',
    'LandingPage.NoAccount': '¿No estás registrado aún?',
    'LandingPage.Start': '¡Empecemos!',
    "Exchange": "Cambio de divisas",
    "Send": "Pagar factura",
    "Receive": "Cobrar factura",
    "Notifications": "Notificaciones",
    "What we do?": "¿Que hacemos?",
    "Settings": "Configuración",
    "Contact us": "Contactanos",
    'tutorial.welcomeToByppay': 'Bienvenidos a Byppay!',
    'tutorial.Tell': 'Vamos a ver sus funcionalidades.',
    'tutorial.discoverbtn': 'Descubre cómo utilizarlo',
    'tutorial.skipbtn': 'Saltar tutorial',
    'tutorial.text1': 'Las explicaciones estarán a tu disposición en todo momento para ayudarte en el camino.',
    'tutorial.text2': 'Mira este video para tener una mejor idea de los próximos pasos a seguir.',
    'tutorial.nextbtn': 'Siguiente',
    'tutorial.text3': 'Byppay es una aplicación web que te permite pagar facturas 4 veces más barato y 10 veces más rápido.',
    'tutorial.text4': 'Mira este video para obtener información sobre la navegación dentro de la aplicación.',
    'tutorial.text5': 'Byppay te permite pagar, byppagar o recibir el pago de tus facturas, según su situación.',
    'tutorial.text6': '¿Quieres saber más sobre el punto de vista del cliente o del proveedor?',
    'tutorial.text65': 'Si deseas obtener más información sobre el punto de vista del cliente, haz clic en "Quiero que me paguen mis facturas".',
    'tutorial.text7': 'Si deseas pagar o byppagar tus facturas pendientes,mira este video para comprender mejor el punto de vista del cliente o contratista.',
    'tutorial.text8': 'Si quieres que te paguen tus facturas pendientes,mira este video para comprender mejor el punto de vista del proveedor.',
    'tutorial.paybtn': 'Quiero pagar mis facturas',
    'tutorial.getpaidbtn': 'Quiero que me paguen mis facturas',
    'tutorial.endtutorial': 'Acabar tutorial',
    'Popup.verify': 'Verifica tu cuenta',
    'Formulary.AddContact': 'Añade contacto',
    'Formulary.ChooseAContact': 'Elije contacto',
    'Formulary.Contact Name': 'Nombre',
    'Formulary.Contact NIF/CIF': 'NIF/CIF',
    'Formulary.Contact Email': 'Email',
    'Formulary.Contact phone': 'Teléfono',

    'Working.onIt' : 'Estamos trabajando en ello',
    'We.areWorking': '¡Estamos trabajando en esta característica!'


};
